// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6e342249","186":"f80dfa0b","344":"6556f56a","372":"2a0d6274","738":"58250c03","841":"3dc0cb6b","851":"5fb2e1ac","856":"1b76115b"}[chunkId] + ".chunk.js";
};